import { signIn, wcsEditEmail, wcsEditPassword } from "../../../utils/auth/signIn.js";
import { signOut } from "../../../utils/auth/signOut.js";
import { isWcsSessionEstablished, kmsi, isKmsiSession } from "../../../utils/auth/wcsToken/index.js";
import { useCallback } from "react";
import { useMSALUtils } from "../useMSALUtils/index.js";
import { useWcsToken } from "../useWcsToken/index.js";
const useAuth = () => {
  const { getTokenValue, isLoading } = useWcsToken();
  const {
    msalEnabledFeatureFlag,
    msalInstanceLoaded,
    signinWithParam,
    signout,
    handleRedirectPromise,
    getTokenSilent,
    editPassword,
    editEmail,
    isMSALKmsiSession
  } = useMSALUtils() || {};
  const signIn$1 = useCallback(
    async (fromPage) => {
      if (msalEnabledFeatureFlag) {
        console.log("MSAL signIn called with");
        await signinWithParam(fromPage);
      } else {
        await signIn(fromPage);
      }
    },
    [msalEnabledFeatureFlag, signinWithParam]
  );
  const signOut$1 = useCallback(async () => {
    if (msalEnabledFeatureFlag) {
      await signout();
    } else {
      await signOut();
    }
  }, [msalEnabledFeatureFlag, signout]);
  const isUserSignedIn = useCallback(async () => {
    if (msalEnabledFeatureFlag) {
      const account = await handleRedirectPromise();
      return Boolean(account);
    } else {
      return isWcsSessionEstablished();
    }
  }, [handleRedirectPromise, msalEnabledFeatureFlag]);
  const getToken = useCallback(
    async (skipSignIn = false) => {
      if (msalEnabledFeatureFlag) {
        return await getTokenSilent(skipSignIn);
      } else {
        return await getTokenValue(skipSignIn);
      }
    },
    [getTokenSilent, getTokenValue, msalEnabledFeatureFlag]
  );
  const editEmailRedirect = useCallback(async () => {
    if (msalEnabledFeatureFlag) {
      await editEmail();
    } else {
      await wcsEditEmail();
    }
  }, [msalEnabledFeatureFlag, editEmail]);
  const editPasswordRedirect = useCallback(async () => {
    if (msalEnabledFeatureFlag) {
      await editPassword();
    } else {
      await wcsEditPassword();
    }
  }, [msalEnabledFeatureFlag, editPassword]);
  const kmsi$1 = useCallback(async () => {
    if (msalEnabledFeatureFlag) {
      return await getTokenSilent();
    } else {
      return await kmsi();
    }
  }, [getTokenSilent, msalEnabledFeatureFlag]);
  const isKmsiSession$1 = useCallback(async () => {
    if (msalEnabledFeatureFlag) {
      return await isMSALKmsiSession();
    } else {
      return isKmsiSession();
    }
  }, [msalEnabledFeatureFlag, isMSALKmsiSession]);
  return {
    signIn: signIn$1,
    signOut: signOut$1,
    isUserSignedIn,
    getToken,
    handleRedirectPromise,
    editEmailRedirect,
    editPasswordRedirect,
    kmsi: kmsi$1,
    isKmsiSession: isKmsiSession$1,
    isLoading: isLoading || msalEnabledFeatureFlag && !msalInstanceLoaded
  };
};
export {
  useAuth
};
